import { decrypt } from '../../utils/security'
import { getCookieValue } from '../../utils/utils'
const IsLoggedIn = (isCorporate) => {
  const loginType = localStorage.getItem('clickedLogin')
  const customerCode = JSON.parse(localStorage.getItem('customerCode'))
  const goToUserChosenRouteChk = JSON.parse(sessionStorage.getItem('preLoginUrl_called'))
  const goToUserChosenRoute = sessionStorage.getItem('preLoginUrl')

  let cookieValue
  if (customerCode) {
    cookieValue = 'customer-code-token'
  } else {
    if (loginType === 'Paltel') {
      cookieValue = 'paltel-corp-token'
    } else if (loginType === 'Jawwal') {
      cookieValue = 'corp-token'
    }
  }

  let url = window.location.href
  let valuesToCheck = ['corporate', '-roots-']
  let containsValue = valuesToCheck.some((value) => url.includes(value))


  if (goToUserChosenRouteChk) {

    let valuesToCheckforPaltel = ['paltel-corporate-main']
    let containsPaltel = valuesToCheckforPaltel.some((value) =>
      goToUserChosenRoute.includes(value)
    )
    if (containsPaltel) {
      localStorage.setItem('clickedLogin', 'Paltel')
      cookieValue = 'paltel-corp-token'
    } else if (valuesToCheck) {
      localStorage.setItem('clickedLogin', 'Jawwal')
      cookieValue = 'corp-token'
    }
  }

  // let url = window.location.href.includes('corporate')


  let coockieValue = !containsValue ? 'token' : cookieValue

  return !!decrypt(getCookieValue(coockieValue))
}

export default IsLoggedIn
